<template>
  <component :is="tag" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import BrbThumbnail from './components/BrbThumbnail.vue'
import BrbVideo from './components/BrbVideo.vue'
import { getExtension } from '@/utils/file-helper'

export default {
  name: 'BrbMedia',
  inheritAttrs: false,
  components: {
    BrbThumbnail,
    BrbVideo
  },
  computed: {
    tag() {
      if (this.isVideo) return 'brb-video'
      return 'brb-thumbnail'
    },
    isVideo() {
      const extensions = new Set(['mp4', 'webm', 'wmv', 'flv', 'avi', 'mov'])
      return extensions.has(getExtension(this.$attrs.src))
    }
  }
}
</script>
